
import { Component, OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { MembershipFormData, Leadership, Site } from "../../bpg-common/services/data.services";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router } from '@angular/router';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';

@Component({
  selector: 'app-bpg-interest',
  templateUrl: './bpg-interest.component.html',
  styleUrls: ['./bpg-interest.component.css']
})
export class BpgInterestComponent implements OnInit {

  /**
   * @class BpgInterestComponent
   * @constructor
   */
  constructor(private readonly membershipService: BpgMembershipService,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly router: Router,
    
    private readonly environment: EnvironmentConfiguration) { }

  savedData: any;
  interestList: any[] = [];
  selectedInterest: any[] = [];
  formData: MembershipFormData[];
  firstCategory: any[] = [];
  secondCategory: any[] = [];
  thirdCategory: any[] = [];
  bpgList: any[] = [];
  skillsList: any[] = [];
  siteList: Site;
  leadershipList: Leadership = new Leadership();
  demographicsList: any[] = [];
  otherSKills: string;
  savedMembershipForm: any;
  mastercheckbox1 = false;
  mastercheckbox2 = false;
  mastercheckbox3 = false;
  countOfFirstCategory = 0;
  countOfSecondCategory = 0;
  countOfThirdCategory = 0;
  back = false;
  status: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;

  loginData: any;
  corporateType: string;
  isCorporateUser = false;

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    this.formData = [];
    this.savedMembershipForm = JSON.parse(sessionStorage.getItem('previousMembershipDetails'));
    this.savedData = JSON.parse(sessionStorage.getItem('MembershipData'));

    this.loginData = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';
    this.corporateType = (this.loginData.corporatePartnerType !== null && this.loginData.corporatePartnerType !== undefined) ? this.loginData.corporatePartnerType.trim() : '';
    if (this.corporateType.toUpperCase() === "CONTINGENT" || this.corporateType.toUpperCase() === "TECHNICAL CONTRACTOR") {
      this.isCorporateUser = true;
    }

    this.spinnerService.show();
    if (this.savedData[0].siteFormData !== undefined) {
      this.siteList = this.savedData[0].siteFormData;
    } else {
      this.siteList = undefined;
    }
    if (this.savedData[0].skillsFormData !== undefined) {
      this.skillsList = this.savedData[0].skillsFormData;
    } else {
      this.skillsList = [];
    }
    if (this.savedData[0].bpgFormData !== undefined) {
      this.bpgList = this.savedData[0].bpgFormData;
    } else {
      this.bpgList = [];
    }
    if (this.savedData[0].leadershipFormData !== undefined) {
      this.leadershipList = this.savedData[0].leadershipFormData;
    } else {
      this.leadershipList = null;
    }
    if (this.savedData[0].otherSkillsFormData !== undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }

    this.membershipService.getAreasOfImpact().subscribe(data => {
      this.interestList = data;
      this.timeOutError = false;
      this.spinnerService.hide();
      const groupByName = {};
      this.interestList.forEach(function (a) {
        groupByName[a.category] = groupByName[a.category] || [];
        groupByName[a.category].push({ areaOfImpactId: a.areaOfImpactId, subCategory: a.subCategory });

      });

      this.firstCategory = groupByName["Work Force Inclusion"];
      this.secondCategory = groupByName["Work Place Engagement"];
      this.thirdCategory = groupByName["Market Place Connection"];

      if (this.savedData[0].interestFormData !== undefined) {
        this.status = localStorage.getItem('status');

        if (this.savedData[0].interestFormData.length > 0) {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.firstCategory[i].areaOfImpactId === this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.firstCategory[i].checked = true;
                this.countOfFirstCategory = this.countOfFirstCategory + 1;
                this.selectedInterest.push(this.firstCategory[i]);
              }
            }
          }
          if (this.countOfFirstCategory === this.firstCategory.length) {
            this.mastercheckbox1 = true;
          }

          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.secondCategory[i].areaOfImpactId === this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.secondCategory[i].checked = true;
                this.countOfSecondCategory = this.countOfSecondCategory + 1;
                this.selectedInterest.push(this.secondCategory[i]);
              }
            }
          }
          if (this.countOfSecondCategory === this.secondCategory.length) {
            this.mastercheckbox2 = true;
          }

          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.thirdCategory[i].areaOfImpactId === this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.thirdCategory[i].checked = true;
                this.countOfThirdCategory = this.countOfThirdCategory + 1;
                this.selectedInterest.push(this.thirdCategory[i]);
              }
            }
          }
          if (this.countOfThirdCategory === this.thirdCategory.length) {
            this.mastercheckbox3 = true;
          }
        }

        else if (this.savedData[0].interestFormData.length === 0 && this.status === 'true') {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            this.firstCategory[i].checked = false;
          }
          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            this.secondCategory[i].checked = false;
          }
          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            this.thirdCategory[i].checked = false;
          }
        }

        if (this.savedMembershipForm.areaOfImpactIds.length > 0) {

          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.firstCategory[i].areaOfImpactId === this.savedMembershipForm.areaOfImpactIds[j]) {
                this.firstCategory[i].checked = true;
                this.countOfFirstCategory = this.countOfFirstCategory + 1;
                this.selectedInterest.push(this.firstCategory[i]);
              }
            }
          }
          if (this.countOfFirstCategory === this.firstCategory.length) {
            this.mastercheckbox1 = true;
          }


          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.secondCategory[i].areaOfImpactId === this.savedMembershipForm.areaOfImpactIds[j]) {
                this.secondCategory[i].checked = true;
                this.countOfSecondCategory = this.countOfSecondCategory + 1;
                this.selectedInterest.push(this.secondCategory[i]);
              }
            }
          }
          if (this.countOfSecondCategory === this.secondCategory.length) {
            this.mastercheckbox2 = true;
          }

          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.thirdCategory[i].areaOfImpactId === this.savedMembershipForm.areaOfImpactIds[j]) {
                this.thirdCategory[i].checked = true;
                this.countOfThirdCategory = this.countOfThirdCategory + 1;
                this.selectedInterest.push(this.thirdCategory[i]);
              }
            }
          }
          if (this.countOfThirdCategory === this.thirdCategory.length) {
            this.mastercheckbox3 = true;
          }
        }


      }
    }, err => {
      this.spinnerService.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** To send data to next page
   * @class BpgInterestComponent
   * @method saveData
   */
  public saveData() {
    localStorage.setItem('status', 'true');
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.selectedInterest, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0);

  }

  /** To send data to previous page
   * @class BpgInterestComponent
   * @method redirectToBpg
   */
  public redirectToBpg() {
    localStorage.setItem('status', 'true');
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.selectedInterest, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0);

  }

  /** to select the checkbox
   * @class BpgInterestComponent
   * @method toggleCheckbox
   */

  toggleCheckbox(event, data, val) {
    if (event.target.checked) {
      data.checked = true;
      this.selectedInterest.push(data);
    } else {
      if (val === 1) {
        this.mastercheckbox1 = false;
      }
      if (val === 2) {
        this.mastercheckbox2 = false;
      }
      if (val === 3) {
        this.mastercheckbox3 = false;
      }

      const index: number = this.selectedInterest.indexOf(data);
      if (index !== -1) {
        data.checked = false;
        this.selectedInterest.splice(index, 1);
      }
    }

  }

  /**skips the selected data and goes to next page
     * @class BpgInterestComponent
     * @method skipInterest
     */
  public skipInterest() {
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: [], skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    localStorage.setItem('status', 'false');
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }

  /**select all work force inclusion master checkbox
     * @class BpgInterestComponent
     * @method selectAllWorkforceInclusion
     */
  selectAllWorkforceInclusion(event) {
    if (event.target.checked) {
      for (const first of  this.firstCategory) {
        if (this.selectedInterest.indexOf(first) === -1) {
          first.checked = true;
          this.selectedInterest.push(first);
        }
      }
    }
    else {
      for (const first1 of this.firstCategory) {
        first1.checked = false;

        const index = this.selectedInterest.indexOf(first1);
        if (index !== -1) {
          this.selectedInterest.splice(index, 1);
        }

      }

    }

  }

  /**select all work force engagement master checkbox
* @class BpgInterestComponent
* @method selectAllWorkforceEngagement
*/

  selectAllWorkforceEngagement(event) {
    if (event.target.checked) {
      for (const second1 of this.secondCategory) {
        if (this.selectedInterest.indexOf(second1) === -1) {
          second1.checked = true;
          this.selectedInterest.push(second1);
        }
      }

    }

    else {
      for (const second of this.secondCategory) {
        second.checked = false;

        const index = this.selectedInterest.indexOf(second);
        if (index !== -1) {
          this.selectedInterest.splice(index, 1);
        }
      }
    }

  }
  /**select all work force marketplace connection master checkbox
     * @class BpgInterestComponent
     * @method selectAllMarketplaceConnection
     */
  selectAllMarketplaceConnection(event) {
    if (event.target.checked) {

      for (const third of this.thirdCategory) {
        if (this.selectedInterest.indexOf(third) === -1) {
          third.checked = true;
          this.selectedInterest.push(third);
        }
      }
    }

    else {
      for (const third1 of this.thirdCategory) {
        third1.checked = false;
        const index = this.selectedInterest.indexOf(third1);
        if (index !== -1) {
          this.selectedInterest.splice(index, 1);
        }
      }
    }

  }
}









